export function useMarket() {
    const { locale } = useI18n();
    const appConfig = useAppConfig();

    const market = computed<Market>(() => {
        const localeToMarket = appConfig.localeToMarket as Record<string, Market>;
        return localeToMarket[locale.value] || 'se';
    });

    const country = computed<Country>(() => {
        const marketToCountry = appConfig.marketToCountry as Record<Market, Country>;
        return marketToCountry[market.value] || 'SE';
    });

    const language = computed<Language>(() => {
        const localeToLanguage = appConfig.localeToLanguage as Record<string, Language>;
        return localeToLanguage[locale.value] || 'en';
    });

    return { market, country, language, locale };
}
